import { useCallback, useEffect, useState } from "react";
import {
  getActivityLeaders,
  getActivityProducts,
} from "../api/activitiesApi";

export function useActivityReferenceData({ date, campus }) {
  const [leaders, setLeaders] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!date) {
      setLeaders([]);
      setProducts([]);
      setError(null);
      return;
    }

    const validCampus =
      campus && campus !== "UNASSIGNED" ? campus : null;

    setLoading(true);
    setError(null);

    try {
      const [leadersResult, productsResult] = await Promise.all([
        validCampus ? getActivityLeaders(date, validCampus) : Promise.resolve([]),
        getActivityProducts(date),
      ]);

      setLeaders(Array.isArray(leadersResult) ? leadersResult : []);
      setProducts(Array.isArray(productsResult) ? productsResult : []);
    } catch (e) {
      console.error("Failed to load activity reference data:", e);
      setError(e);
      setLeaders([]);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, [date, campus]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    leaders,
    products,
    loading,
    error,
    refetch: load,
  };
}